module.exports = __webpack_public_path__ + "static/media/29BDOS9.3a3f85fe.jpg";